// state
import current_form from "@/state/current_form"
import email from "@/state/email"
import emailSentTo from "@/state/emailSentTo"
import isDisplayEmailSentMessage from "@/state/isDisplayEmailSentMessage"

// Enum
import UserInfoFormEnum from "@/config/UserInfoFormEnum"

const handleEmailSent = (): void => {
	emailSentTo.value = email.value
	isDisplayEmailSentMessage.value = true
	current_form.value = UserInfoFormEnum.Login
}

export default handleEmailSent
